import styled, { css } from "styled-components/macro";

type TBaseStyles = {
  $isBlack?:  boolean
}

export const baseButtonStyles = css<TBaseStyles>`
  padding: 16px 24px;
  font-weight: 500;
  background-color: #fff;
  color: inherit;
  border: 1px solid #141414;
  height: 50px;
  cursor: pointer;
  border-radius: 30px;
  font-size: 18px;
  line-height: 18px;
  text-decoration: none;
  text-align: center;
  display: block;
  align-items: center;
  gap: 10px;
  transition: 0.2s;

  &:hover {
    transition: 0.2s;
    background-color: #000;
    color: #fff;
    border-color: #000;
  }

  @media (max-width: 576px) {
    width: 100%;
    display: block;
    text-align: center;
    font-size: 16px;
  }
    
  ${({ $isBlack }) => $isBlack
    ? css`
      background-color: #141414;
      color: #fff;
      border-color: #141414;
        
        &:hover {
          color: #141414;
          background-color: #fff;
        }
    `
    : ""};
`;

export const Section = styled.section`
  margin-bottom: 80px;
  
  @media (max-width: 1439px) {
    margin-bottom: 40px;
  }
  
  &:last-child {
    margin-bottom: 40px;
  }

  @media (max-width: 979px) {
    margin-left: 12px;
    margin-right: 12px;
    margin-bottom: 80px;
  }
`

export const TitleH1 = styled.h1`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 65px;
  line-height: 117%;
  margin-bottom: 40px;
  text-align: center;
  font-weight: 600;

  @media (max-width: 1439px) {
    font-size: 50px;
    line-height: 120%;
    margin-bottom: 36px;
  }

  @media (max-width: 979px) {
    font-size: 38px;
    margin-bottom: 40px;
  }
`

export const TitleH2 = styled.h2`
  font-family: "Cormorant Infant", sans-serif;
  font-size: 57px;
  font-weight: 600;
  max-width: 648px;
  text-align: center;
  margin-bottom: 36px;

    span {
      color: #55749F;
    }

  @media (max-width: 1439px) {
    font-size: 45px;
  }

  @media (max-width: 979px) {
    font-size: 38px;
    margin-bottom: 24px;
  }
`

export const SmallTitle = styled.p<{isWhite?: boolean}>`
  font-size: 16px;
  font-weight: 400;
  color: ${({ isWhite }) => isWhite ? "#fff" : "#141414"};
  text-transform: uppercase;
  margin-bottom: 14px;

  @media (max-width: 1439px) {
    margin-bottom: 10px;
  }
  
  @media (max-width: 979px) {
    font-size: 13px;
    margin-bottom: 12px;
  }
`;

export const MobileMenuHeader = styled.header`
  position: relative;
  width: 1320px;
  min-height: 64px;
  margin: 18px auto;
  padding: 0 15px;
  display: flex;
  align-items: center;
  justify-content: space-between;
  border: 1px solid transparent;
    
  @media (max-width: 1439px) {
    width: calc(100% - 24px);
  }

  @media (max-width: 979px) {
    margin: 12px auto;
    width: calc(100% - 24px);
    min-height: 58px;
  }
`

export const MobileButtonWrapper = styled.div`
  padding: 15px;
`

export const Container = styled.div`
  display: flex;
  align-items: center;
  justify-content: center;
`
